import { FC, useMemo, useState } from "react";
import "./SelectDate.css";

const weekDays = ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'];

const SelectDate: FC<{
    onDateChange: (date: string) => void,
    selectedDate: Date
}> = ({ onDateChange, selectedDate }) => {
    const [showDate, setShowDate] = useState(new Date(selectedDate));

    const getAllDaysInMonth = (month: number, year: number) =>
        Array.from(
            { length: new Date(year, month, 0).getDate() },
            (_, i) => new Date(year, month - 1, i + 1)
        );

    const startDayOfFirstWeek = (new Date(showDate.getFullYear(), showDate.getMonth(), 1).getDay() + 6) % 7;
    const endDayOfLastWeek = (new Date(showDate.getFullYear(), showDate.getMonth() + 1, 1).getDay() + 6) % 7;

    const month = useMemo(() => {
        let lastMonth = getAllDaysInMonth(showDate.getMonth(), showDate.getFullYear())
        let thisMonth = getAllDaysInMonth(showDate.getMonth() + 1, showDate.getFullYear())
        let nextMonth = getAllDaysInMonth(showDate.getMonth() + 2, showDate.getFullYear())
        if (endDayOfLastWeek === 0)
            return [
                ...lastMonth.slice(lastMonth.length - startDayOfFirstWeek, lastMonth.length),
                ...thisMonth
            ];
        return [
            ...lastMonth.slice(lastMonth.length - startDayOfFirstWeek, lastMonth.length),
            ...thisMonth,
            ...nextMonth.slice(0, 7 - endDayOfLastWeek)
        ];
    }, [startDayOfFirstWeek, showDate, endDayOfLastWeek]);

    return (
        <>
            <div className="select-date-month d-flex flex-wrap flex-row align-items-center justify-content-center px-2 py-2">
                <button
                    onClick={() => setShowDate(new Date(showDate.setMonth(showDate.getMonth() - 1)))}
                    className="select-date-day-button rounded-circle p-0 border-0"
                >
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.2567 16.3056L20.1885 23.2278C21.2016 23.8155 22.5 23.1047 22.5 21.9223V8.07775C22.5 6.89531 21.2016 6.18447 20.1885 6.77219L8.2567 13.6944C7.24777 14.2798 7.24777 15.7202 8.2567 16.3056Z" fill="#F9F9F9" />
                    </svg>
                </button>
                <div className="h5 my-0 mx-3">
                    {showDate.toLocaleString('it-IT', { month: 'long', year: 'numeric' }).slice(0, 1).toUpperCase() + showDate.toLocaleString('it-IT', { month: 'long', year: 'numeric' }).slice(1)}
                </div>
                <button
                    onClick={() => setShowDate(new Date(showDate.setMonth(showDate.getMonth() + 1)))}
                    className="select-date-day-button rounded-circle p-0 border-0"
                >
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.7433 16.3067L9.81149 23.2289C8.79844 23.8166 7.5 23.1058 7.5 21.9234L7.5 8.07885C7.5 6.89641 8.79844 6.18557 9.81149 6.77329L21.7433 13.6955C22.7522 14.2809 22.7522 15.7213 21.7433 16.3067Z" fill="#F9F9F9" />
                    </svg>
                </button>
            </div>
            <div className="select-date-month d-flex flex-wrap flex-row py-2 border-0">
                {weekDays.map((weekDay) => (
                    <div key={weekDay} className="select-date-day d-flex justify-content-center">
                        <small>{weekDay}</small>
                    </div>
                ))}
            </div>
            <div className="d-flex flex-wrap flex-row">
                {month.map((day) => {
                    const highlightSelectedDate =
                        selectedDate &&
                        selectedDate.getDate() === day.getDate() &&
                        selectedDate.getMonth() === day.getMonth() &&
                        selectedDate.getFullYear() === day.getFullYear();
                    return (
                        <div key={day.toISOString()} className={"select-date-day border d-flex justify-content-center " + (highlightSelectedDate ? "bg-red" : "")}>
                            <button
                                disabled={day.getMonth() !== showDate.getMonth()}
                                onClick={() => onDateChange(day.toISOString())}
                                className={"select-date-day-button py-2 border-0 " + (highlightSelectedDate ? "color-white" : "")}
                            >
                                {day.getDate()}
                            </button>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default SelectDate;